/* api/platform-search — GET /platform/search?q= */
import { get } from './client.js';
export const search = (q) => get(`/platform/search?q=${encodeURIComponent(q)}`);
